import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { NODE_TYPE, Remap } from './remap';
import { UntypedFormArray, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { getEditTypes } from '../../../delegatorUtils';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

@Component({
    selector: 'app-remap',
    templateUrl: './remap.component.html',
    styleUrls: ['./remap.component.scss'],
    imports: [ReactiveFormsModule, ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ClickatellFormValidationComponent, ActiveFormDirective, CMSComponent, NextSelectorComponent]
})
export class RemapComponent extends NodeBuilder implements OnInit {

  remapFrom: UntypedFormGroup;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.remapFrom = Remap.toForm(stepData, this.canEdit);

    if (this.remapFrom.get('yes').value === newStepValue) {
      this.remapFrom.get('yes').setValue('step' + this.getNextStep());
    }
    if (this.remapFrom.get('no').value === newStepValue) {
      this.remapFrom.get('no').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const formData = this.remapFrom.getRawValue();
    const remap = new Remap();
    remap.setNodeData(formData);
    return remap.nodeData;
  }

  get isNodeValid(): boolean {
    this.remapFrom.markAllAsTouched();
    return this.remapFrom.valid;
  }

  public addRemapValue(): void {
    const { editFlows } = getEditTypes(this.canEdit);
    const remapValues: UntypedFormArray = this.remapFrom.get('remapValues') as UntypedFormArray;
    remapValues.push(Remap.remapValueTemplate(undefined, editFlows));
  }

  public deleteRemapValue(index: number): void {
    const remapValues: UntypedFormArray = this.remapFrom.get('remapValues') as UntypedFormArray;
    remapValues.removeAt(index);
  }

}
